import { useEffect } from "react";
import { useLang, useAlternatePath, ROUTES } from "@/i18n";

/**
 * Injects per-page hreflang <link> tags + canonical into <head>.
 * Renders nothing visible. Re-runs on every route / language change.
 */
export default function HreflangTags() {
  const { lang } = useLang();
  const alt = useAlternatePath();

  useEffect(() => {
    if (typeof document === "undefined") return;
    const origin = window.location.origin;
    const currentPath = window.location.pathname;

    // Resolve current page route key by matching the active language
    let currentKey = "home";
    for (const k in ROUTES[lang]) {
      const r = ROUTES[lang][k].replace(/\/+$/, "") || "/";
      if (r === (currentPath.replace(/\/+$/, "") || "/")) {
        currentKey = k;
        break;
      }
    }

    const enHref = `${origin}${ROUTES.en[currentKey] || "/"}`;
    const deHref = `${origin}${ROUTES.de[currentKey] || "/de"}`;
    const xDefault = enHref;
    const canonical = `${origin}${lang === "de" ? ROUTES.de[currentKey] : ROUTES.en[currentKey]}`;

    // Remove any previously injected tags
    document
      .querySelectorAll('link[data-hreflang="artful"], link[data-canonical="artful"]')
      .forEach((el) => el.remove());

    const make = (rel, href, hreflang) => {
      const link = document.createElement("link");
      link.rel = rel;
      link.href = href;
      if (hreflang) {
        link.setAttribute("hreflang", hreflang);
        link.setAttribute("data-hreflang", "artful");
      } else {
        link.setAttribute("data-canonical", "artful");
      }
      document.head.appendChild(link);
    };

    make("alternate", enHref, "en");
    make("alternate", deHref, "de");
    make("alternate", xDefault, "x-default");
    make("canonical", canonical);
  }, [lang, alt.path]);

  return null;
}
